<!-- 产品类别 -->
<template>
  <BaseFormItem
    class="board_type"
    :label="fields.label"
    :labelTips="fields.labelTips"
  >
    <BaseRadioGroup v-model="val" @change="handleEmit">
      <BaseTipPopover 
        class="board_type__radio"
        placement="top"
        v-for="item in fields.options"
        :key="item.value" 
        :content="item.tips" 
        :disabled="!item.tips"
      >
        <el-radio-button
          slot="reference"
          :label="item.value"
          @click.native.prevent="handleItemClick(item.value)"
        >
          {{ item.label }}
          <img 
            v-if="item.value == 'ROGERS'"
            class="board_type__radio__new" 
            :src="require('@@/assets/img/icons/icon_new.png')" 
          />
        </el-radio-button>
      </BaseTipPopover>
    </BaseRadioGroup>
  </BaseFormItem>
</template>

<script>
import { isMyCenterSite } from '@@/utils/is'
import { targetSelfWindow } from '@@/utils/triggerParent'
import { getFR4Fields } from '@@/utils/getFields'

export default {
  props: {
    value: {
      type: String,
      default: 'FR-4'
    },
  },
  data() {
    return {
      val: this.value
    }
  },
  computed: {
    fields() {
      return getFR4Fields('board_type')
    },
  },
  watch: {
    value(newVal) {
      this.val = newVal
    },
  },
  methods: {
    handleEmit() {
      const val = this.val
      this.$emit('input', val)
      this.$emit('change', val)
    },
    handleItemClick(board_type) {
      if (board_type === 'FPC') {
        // 用户中心站点(DFM)
        if (isMyCenterSite) {
          targetSelfWindow({ path: '/orders/fpc/quote' })
        } else {
          // 新窗口打开
          window.open('/quote_new/fpc/')
        }
      } else {
        this.val = board_type
        this.handleEmit()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.board_type__radio {
  position: relative;
  .board_type__radio__new {
    position: absolute;
    top: -10px;
    right: 6px;
  }
}
</style>